import React, { ReactElement } from 'react'
import DisplaySettings from './DisplaySettings'
import { DashboardLayoutStyle } from './Types'

export type DashboardProps = {
    selectedDashboardLayoutStyle: DashboardLayoutStyle
    setSelectedDashboardLayoutStyle: (value: DashboardLayoutStyle) => void
}

/**
 *
 * @param selectedDashboardLayoutStyle Currently selected layout style for dashboard report.
 * @param setSelectedDashboardLayoutStyle Setter for respective property.
 */
const DashboardTab: React.FC<DashboardProps> = ({
    selectedDashboardLayoutStyle,
    setSelectedDashboardLayoutStyle
}): ReactElement => (
    <div className='dashboard-tab tab-area'>
        <DisplaySettings
            selectedDashboardLayoutStyle={selectedDashboardLayoutStyle}
            setSelectedDashboardLayoutStyle={setSelectedDashboardLayoutStyle}
        />
    </div>
)
export default DashboardTab
